<jhi-custom-box [title]="'spans.forgotPassword.boxtitle'" [requiredFields]="true"
                [successMsg]="successMsg"
                [errorMsg]="errorMsg" [boxSize]="'box-580'"
                (successEmitter)="backToApp()"
                (failureEmitter)="backToApp()">

    <form [formGroup]="passwordForm">

        <div class="row form-group" *ngIf="!confirmData">
            <div class="col-sm-4 mb-auto mt-auto" [ngClass]="{'text-right': isDesktop}">
                <label class="mb-0" for="username-input" jhiTranslate="spans.forgotPassword.formlabels.username">
                    Username </label>
            </div>
            <div class="col-sm-8">
                <input [readOnly]="submitted || confirmData"
                    [placeholder]="'spans.forgotPassword.formplaceholders.username' | translate" id="username-input"
                    type="text" [formControlName]="'username'" class="form-control"
                    [ngClass]="errorCheckStepOne && f.username.errors ? 'is-invalid': ''" />
                <div class="position-absolute error-box"
                    [ngClass]="(errorCheckStepOne && fUsername.invalid) ? '' : 'invisible-space'">
                    <span *ngIf="errorCheckStepOne && fUsername.errors?.required"
                        jhiTranslate="spans.forgotPassword.formerrors.requiredUsername"> Username Error </span>
                </div>
            </div>
        </div>
        <ng-container *ngIf="confirmData">
            <div class="row form-group">
                <div class="col-sm-4 mb-auto mt-auto" [ngClass]="{'text-right': isDesktop}">
                    <label class="mb-0" for="username-input" jhiTranslate="spans.forgotPassword.formplaceholders.username">
                        Username </label>
                </div>
                <div class="col-sm-8">
                    <p class="readOnlyFields">
                        {{passwordForm.controls['username'].value}}
                    </p>
                </div>
            </div>
            <div class="row p-b-1r">
                <div class="col-sm-4 mb-auto mt-auto" [ngClass]="{'text-right': isDesktop}">
                    <label class="mb-0" jhiTranslate="spans.editAccountInfo.formplaceholders.question">
                        Question </label>
                </div>
                <div class="col-sm-8">
                    <p class="readOnlyFields">
                        {{passwordForm.controls['question'].value}}
                    </p>
                </div>
            </div>


            <div class="row">
                <div class="col-sm-4 mb-auto mt-auto" [ngClass]="{'text-right': isDesktop}">
                    <label class="mb-0" for="answer-input" jhiTranslate="spans.editAccountInfo.formlabels.answer">
                        Answer </label>
                </div>
                <div class="col-sm-8 input-group">
                    <input [readOnly]="submitted"
                        [placeholder]="'spans.editAccountInfo.formplaceholders.answer' | translate" id="answer-input"
                        [type]="showAnswer ? 'text' : 'password'" [formControlName]="'answer'" class="form-control"
                        [ngClass]="errorCheckStepTwo && f.answer.errors ? 'is-invalid': ''" />
                    <div class="input-group-append">
                        <button title="{{showAnswer ? 'spans.editAccountInfo.hidePin' : 'spans.editAccountInfo.showPin' | translate}}" type="button"
                                class="btn btn-outline-secondary align-self-start" (click)="changeShowAnswer()">
                            <fa-icon [icon]="showAnswer ? faEye : faEyeSlash"></fa-icon>
                        </button>
                    </div>
                </div>
                <div class="col-sm-4"></div>
                <div class="col-sm-8 align-self-end">
                    <div *ngIf="errorCheckStepTwo && fAnswer.invalid" class="error-box">
                        <span *ngIf="errorCheckStepTwo && fAnswer.errors?.required"
                            jhiTranslate="spans.editAccountInfo.formerrors.requiredAnswer"> Answer required </span>
                    </div>
                </div>
            </div>

            <div class="row m-t-5">
                <div class="col-sm-12">
                    <p jhiTranslate="global.form.select.firstpassword.sending">First password sending</p>

                    <div class="text-orange" *ngIf="confirmData.showPhoneWarning && !channelSMS" jhiTranslate="spans.forgotPassword.warningphonenotvalidated">Attenzione</div>

                    <div class="radio-button">
                        <span class="m-r-10" *ngIf="channelEmail">
                            <input type="radio" [formControlName]="'invio'" id="email" name="invio" value="EMAIL" checked>
                            <label for="email" jhiTranslate="global.form.email">Email</label>
                        </span>
                        <span class="m-r-10" *ngIf="channelEmailAlt">
                            <input type="radio" [formControlName]="'invio'" id="emailSecondaria" name="invio" value="ALT_EMAIL" checked>
                            <label for="emailSecondaria" jhiTranslate="global.form.alternative.email">Alternative email</label>
                        </span>
                        <span class="m-r-10" *ngIf="channelSMS">
                            <input type="radio" [formControlName]="'invio'" id="sms" name="invio" value="SMS" checked>
                            <label for="sms" jhiTranslate="global.form.sms">Sms</label>
                        </span>
                    </div>
                </div>
            </div>
        </ng-container>

        <div class="row p-0 m-b-10" *ngIf="!confirmData && captchaEnabled">
            <div class="col-sm-8">
                <label class="mb-0" for="captcha-input" jhiTranslate="spans.forgotPassword.formlabels.captcha" *ngIf="!isDesktop">
                    Captcha * </label>
                <div class="row">
                    <div class="col-xs-9" [ngClass]="{'text-right': isDesktop}">
                        <img *ngIf="imageToShow" id="captchaimg" alt="captcha" class="captcha-img" [src]="imageToShow">
                    </div>
                    <div class="col-xs-3">
                        <div class="captcha-buttons-container">
                            <button type="button" class="btn mt-0 mb-0" placement="{{ isDesktop ? 'right' : 'top' }}" container="body"
                                    popoverClass="popover-position-fix" ngbPopover="{{'spans.common.captchaPopOver' | translate}}"
                                    popoverTitle="{{'buttons.audioCaptcha' | translate}}" (click)="getCaptchaSound()">
                                <fa-icon class="captcha-icons" [icon]="faVolumeUp"></fa-icon>
                            </button>

                            <button type="button" (click)="getCaptcha()" class="btn m-t-4i mb-0">
                                <fa-icon class="captcha-icons" [icon]="faSyncAlt"></fa-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <input [readOnly]="submitted" [placeholder]="'spans.common.captcha' | translate" id="captcha-input"
                    type="text" [formControlName]="'captcha'" class="m-t-10 form-control"
                    [ngClass]="errorCheckStepOne && f.captcha.errors ? 'is-invalid': ''" />
                <div class="position-absolute error-box"
                    [ngClass]="(errorCheckStepOne && fCaptcha.invalid) ? '' : 'invisible-space'">
                    <span *ngIf="errorCheckStepOne && fCaptcha.errors?.required"
                        jhiTranslate="spans.common.captchaErrors.required"> Mandatory field </span>
                </div>
            </div>
        </div>


        <div class="row text-center d-flex">
            <div class="col-12">
                <button [disabled]="submitted" class="btn secondary-btn float-left" (click)="backToApp()"
                    jhiTranslate="buttons.back">Return to application</button>
                <button [disabled]="submitted" (click)="onReset()" class="btn secondary-btn"
                    jhiTranslate="buttons.reset">reset</button>
                <button [ladda]="submitted" *ngIf="!confirmData" class="btn confirm-btn ladda-button max-w-150"
                        data-style="expand-right" (click)="onSubmit($event)" >
                    <span class="ladda-label" jhiTranslate="buttons.ahead"> ahead</span>
                </button>
                <button [ladda]="submitted" *ngIf="confirmData" class="btn confirm-btn ladda-button max-w-150"
                        data-style="expand-right" (click)="onSubmit($event)" >
                    <span class="ladda-label" jhiTranslate="buttons.submit" > confirm</span>
                </button>
            </div>

        </div>
    </form>
</jhi-custom-box>
